export default __webpack_public_path__ + "static/social_comply_box_d-d486c9b97e8c2202dc22069dfb2d4429.png";